import dayjs from 'dayjs';

export const BalanceLabel = ['Max Balance Limit', 'Min Balance Limit', 'Balance'];
export const dashboardDayCount = 5;
export const dashboardStartDate = dayjs().subtract(dashboardDayCount, 'day').startOf('day');
export const dashboardEndDate = dayjs().endOf('day');



// WEBPACK FOOTER //
// ./src/constants/dashboard.constants.ts